import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, CheckCircle2 } from 'lucide-react';

/**
 * Newsletter compacte — même design que le bloc newsletter du Hero de la home.
 * Utilisée sur les pages Formations et Prestations.
 */
export function NewsletterHero() {
  const { t } = useTranslation();
  const substackUrl = 'https://corentinleroux.substack.com';
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;

    fetch(`${substackUrl}/api/v1/free`, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ email }),
    });

    setSubscribed(true);
  };

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="bg-white border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row justify-between items-center gap-6 shadow-sm">
          {/* Icône + texte */}
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-10 h-10 rounded-full bg-aspexit-green/10 flex items-center justify-center">
              {subscribed ? (
                <CheckCircle2 className="w-5 h-5 text-aspexit-green" />
              ) : (
                <Mail className="w-5 h-5 text-aspexit-green" />
              )}
            </div>
            <div>
              <h3 className="font-heading font-bold text-aspexit-black text-base">
                {subscribed ? t('newsletter.success') : t('newsletter.joinTitle')}
              </h3>
              <p className="text-sm text-aspexit-gray hidden sm:block">
                {subscribed ? t('newsletter.poweredBy') : t('newsletter.description')}
              </p>
            </div>
          </div>

          {/* Formulaire */}
          {!subscribed && (
            <form
              onSubmit={handleSubmit}
              className="w-full md:w-auto flex gap-0 border-b-2 border-gray-300 focus-within:border-aspexit-green transition-colors"
            >
              <input
                type="email"
                name="email"
                placeholder={t('newsletter.emailPlaceholder')}
                required
                className="bg-transparent border-none focus:ring-0 text-aspexit-black py-3 px-0 w-full md:w-64 placeholder:text-gray-400 text-sm outline-none"
              />
              <button
                type="submit"
                className="text-aspexit-green font-bold uppercase tracking-widest text-xs px-4 py-3 hover:text-aspexit-green-dark transition-colors whitespace-nowrap"
              >
                {t('newsletter.subscribe')}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
